import React, { FC, useCallback, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as yup from 'yup'

import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

import {
  FormSchema,
} from '@kaidam/fc-frontend/src/types/form'

import {
  IData_Booking_Single_Payment,
} from '@kaidam/fc-shared/src/types/schema/booking'

import {
  ThunkDispatcher,
} from '../types/store'

import Form from '@kaidam/fc-frontend/src/components/form/Wrapper'

import paymentActions from '../store/modules/payment'

const formSchema: FormSchema = [{
  id: 'amount',
  title: 'Amount',
  helperText: 'Please enter the amount you want to pay in pounds (e.g 57.45)',
  inputProps: {
    type: 'number',
  }
}, {
  id: 'email',
  title: 'Email',
  helperText: 'Please enter your email address',
}]

const validationSchema = yup.object().shape({
  amount: yup.number().required(),
  email: yup.string().email().required(),
})

const Pay: FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useDispatch()
  const thunkDispatch = dispatch as ThunkDispatcher
  const [ submitting, setSubmitting ] = useState(false)

  const initialValues: IData_Booking_Single_Payment = {
    amount: 0,
    email: '',
  }

  const onPay = useCallback(async (data: IData_Booking_Single_Payment) => {
    const submitData = Object.assign({}, data)
    // convert pounds to pence
    submitData.amount = Math.round(data.amount * 100)
    setSubmitting(true)
    await thunkDispatch(paymentActions.makeSinglePayment(submitData))
    setSubmitting(false)
  }, [])

  return (
    <Container 
      maxWidth="lg" 
      sx={{ p: 4 }}
    >
      <Paper sx={{ p: 4 }}>
        <Typography gutterBottom variant="h6">
          Make Payment
        </Typography>
        <Form
          validationSchema={ validationSchema }         
          error={ "" }
          initialValues={ initialValues }
          onSubmit={ onPay }
        >
          {
            ({
              render,
              isValid,
              onSubmit,
            }) => {
              return (
                <div>
                  { render(formSchema) }
                  <Box sx={{ mt: 4 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={ submitting }
                      type="submit"
                      onClick={ onSubmit }
                    >
                      Make Payment
                    </Button>
                  </Box>
                </div>
                
              )
            }
          }
        </Form>
      </Paper>
    </Container>
  )
}

export default Pay